import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className=" py-4  justify-center bottom-0 w-full">
      <div className="container mx-auto px-4">
        <p className="text-center text-gray-500">
          &copy; {currentYear} simpleTodoList. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
